var _g, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPauseCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 0c282.77 0 512 229.23 512 512s-229.23 512-512 512c-282.77 0-512-229.23-512-512s229.23-512 512-512z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M511.983 170.669c-188.533 0-341.333 152.8-341.333 341.331 0 188.534 152.8 341.335 341.333 341.335 188.535 0 341.331-152.801 341.331-341.335 0-188.531-152.796-341.331-341.331-341.331zM469.317 425.469v170.668c0 24.796-19.066 43.863-42.666 43.863s-42.667-19.067-42.667-42.665v-171.866c0-22.4 19.067-41.467 41.467-41.467s43.867 19.067 43.867 41.467zM639.985 425.469v170.668c0 24.796-19.067 43.863-42.67 43.863-23.598 0-42.665-19.067-42.665-42.665v-171.866c0-22.4 19.067-41.467 41.467-41.467s43.868 19.067 43.868 41.467z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPauseCircle);
export default __webpack_public_path__ + "static/media/icon-pause-circle.0316f7c9e0553f03ed519a204da5ef8a.svg";
export { ForwardRef as ReactComponent };